var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Star_Filled_Copy",
    "data-name": "icons/Star/Filled Copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.333,
    height: 6,
    viewBox: "0 0 9.333 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke_",
    "data-name": "vector (Stroke)",
    d: "M7,.214,9.157,2.548a.667.667,0,0,1,0,.9L7,5.786a.667.667,0,0,1-.98-.9L7.144,3.667H.667a.667.667,0,1,1,0-1.333H7.144L6.023,1.119A.667.667,0,1,1,7,.214Z",
    transform: "translate(0)",
    fill: "#23262f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisIcon);
export default __webpack_public_path__ + "static/media/disIcon.d50154840b4fb2a44f738c79b5e9332c.svg";
export { ForwardRef as ReactComponent };